// extracted by mini-css-extract-plugin
export default {"root":"MacroNutrient-root","dailyGoal":"MacroNutrient-dailyGoal"};